import {
  getClosestPackage,
  getPredefinedPackageSize,
  PredefinedPackage,
} from 'app/models/predefinedPackageModel'

import * as React from 'react'
import FlexView from '@/modules/shared/components/FlexView'

type PackageProps = {
  activeDriversLimits?: number
  predefinedPackage?: number
  packageMultiplier: number
  packageAmount: number
  additionalPaidDrivers?: number
  driversCount?: number
  enableTooltip: boolean
  isHeader: boolean
  title?: string
  onValue?: (event: React.ChangeEvent<HTMLInputElement>) => void
  translate: (string) => any
}
type PackageState = {}

const COLORS = {
  None: '#808080',
  WebLite1: '#007F7F',
  Web5: '#FF6A88',
  Web20: '#AA6A88',
  Web50: '#A8A85F',
  Web100: '#267F00',
  Web250: '#FF7519',
  WebPro: '#004A7F',
}

export class Package extends React.Component<PackageProps, PackageState> {
  constructor(props: PackageProps) {
    super(props)
  }

  determineActiveDriversColor = (
    predefinedPackage?: PredefinedPackage,
    driversCount?: number,
    activeDriversLimits?: number,
    isHeader: boolean = false,
  ) => {
    if (
      predefinedPackage == null ||
      predefinedPackage == 0 ||
      driversCount == null ||
      activeDriversLimits == null
    ) {
      return isHeader ? '#808080' : '#000'
    }

    if (driversCount > activeDriversLimits) {
      return '#F00'
    }

    const percentage = (driversCount * 100) / activeDriversLimits
    return percentage >= 90 ? '#FF6A00' : isHeader ? '#808080' : '#000'
  }

  render() {
    const {
      activeDriversLimits,
      predefinedPackage,
      packageMultiplier,
      isHeader,
      driversCount,
      enableTooltip,
      title,
      translate,
      additionalPaidDrivers,
    } = this.props
    const packageSize =
      (activeDriversLimits > 0
        ? activeDriversLimits
        : getPredefinedPackageSize(predefinedPackage, activeDriversLimits)) *
      (packageMultiplier > 1 ? packageMultiplier : 1)
    const driversNotInPackage =
      (predefinedPackage == null || predefinedPackage == 0) &&
      (activeDriversLimits == null || activeDriversLimits == 0)
        ? 0
        : driversCount - additionalPaidDrivers > packageSize
          ? driversCount - additionalPaidDrivers - packageSize
          : 0
    const closestPackage =
      activeDriversLimits > 0
        ? getClosestPackage(activeDriversLimits)
        : predefinedPackage

    return (
      <FlexView
        data-tip
        data-for="global"
        hAlignContent="right"
        style={{
          textAlign: 'right',
          width: '100%',
          marginTop: isHeader ? -3 : 0,
        }}
      >
        <FlexView
          hAlignContent="right"
          style={{ textAlign: 'right', width: '100%' }}
        >
          {true && (
            <FlexView
              vAlignContent="center"
              hAlignContent="right"
              style={{
                marginLeft: isHeader ? 10 : 5,
                paddingLeft: isHeader ? 10 : 8,
                paddingRight: isHeader ? 10 : 8,
                paddingTop: 4,
                paddingBottom: 4,
                height: isHeader ? 48 : 21,
                color: 'white',
                fontSize: isHeader ? 14 : 12,
                fontWeight: 500,
                marginTop: isHeader ? -2 : 0,
              }}
            >
              {
                <FlexView
                  vAlignContent="center"
                  hAlignContent="center"
                  style={{
                    paddingLeft: isHeader ? 10 : 6,
                    paddingRight: isHeader ? 10 : 6,
                    background: !isHeader
                      ? 'transparent'
                      : this.determineActiveDriversColor(
                          closestPackage,
                          driversCount -
                            (additionalPaidDrivers != null
                              ? additionalPaidDrivers
                              : 0),
                          packageSize,
                          isHeader,
                        ),
                    height: 48,
                  }}
                >
                  {title != null && (
                    <img
                      src="/assets/icons_nucleo/icons/mix/kierowcy.white.svg"
                      style={{ marginRight: 10, width: 19, height: 19 }}
                    />
                  )}
                  {isHeader && (
                    <span style={{ fontSize: 14, marginTop: 2 }}>
                      <span
                        style={{ fontSize: 14, fontWeight: 500, color: '#fff' }}
                      >
                        {driversCount ? driversCount : '?'}
                      </span>
                      {driversNotInPackage > 0 && (
                        <span
                          style={{
                            marginLeft: 2,
                            fontSize: 14,
                            fontWeight: 500,
                            color: '#fff',
                          }}
                        >
                          {'(+' + driversNotInPackage + ')'}
                        </span>
                      )}
                    </span>
                  )}
                  {!isHeader && (
                    <span style={{ fontSize: 14, marginTop: 2 }}>
                      <span
                        style={{
                          fontSize: 14,
                          fontWeight: 500,
                          color: this.determineActiveDriversColor(
                            closestPackage,
                            driversCount -
                              (additionalPaidDrivers != null
                                ? additionalPaidDrivers
                                : 0),
                            packageSize,
                          ),
                        }}
                      >
                        {driversCount ? driversCount : '?'}
                      </span>
                      {driversNotInPackage > 0 && (
                        <span
                          style={{
                            marginLeft: 2,
                            fontSize: 14,
                            fontWeight: 500,
                            color: this.determineActiveDriversColor(
                              closestPackage,
                              driversCount -
                                (additionalPaidDrivers != null
                                  ? additionalPaidDrivers
                                  : 0),
                              packageSize,
                            ),
                          }}
                        >
                          {'(+' + driversNotInPackage + ')'}
                        </span>
                      )}
                    </span>
                  )}
                </FlexView>
              }
              {((predefinedPackage != null && predefinedPackage != 0) ||
                activeDriversLimits > 0) && (
                <FlexView
                  vAlignContent="center"
                  hAlignContent="center"
                  style={{
                    paddingLeft: isHeader ? 10 : 6,
                    paddingRight: isHeader ? 10 : 6,
                    background: COLORS[PredefinedPackage[closestPackage]],
                    height: isHeader ? 48 : 21,
                  }}
                >
                  {predefinedPackage != null && predefinedPackage != 0 && (
                    <span
                      style={{ marginTop: 2 }}
                    >{`${PredefinedPackage[closestPackage].toLowerCase().replace('web', 'pro').toUpperCase()}`}</span>
                  )}

                  {packageMultiplier > 1 && (
                    <span
                      style={{
                        marginTop: 2,
                        marginLeft: 4,
                        fontSize: isHeader ? 14 : 12,
                        color: '#fff',
                        textTransform: 'none',
                      }}
                    >
                      {'x' + packageMultiplier}
                    </span>
                  )}

                  {(predefinedPackage == null || predefinedPackage == 0) &&
                    activeDriversLimits > 0 && (
                      <FlexView
                        vAlignContent="center"
                        hAlignContent="right"
                        style={{
                          marginLeft: isHeader ? -10 : -6,
                          background: COLORS[PredefinedPackage[closestPackage]],
                          paddingLeft: isHeader ? 10 : 6,
                          paddingRight: 0,
                          height: isHeader ? 48 : 21,
                          color: 'white',
                          fontSize: isHeader ? 14 : 12,
                          fontWeight: 500,
                        }}
                      >
                        <span style={{ marginTop: 2 }}>
                          {'Pro' + activeDriversLimits}
                        </span>
                      </FlexView>
                    )}
                  {additionalPaidDrivers != null &&
                    additionalPaidDrivers > 0 && (
                      <span
                        style={{
                          marginTop: 2,
                          marginLeft: 4,
                          fontSize: isHeader ? 14 : 12,
                          color: '#fff',
                          textTransform: 'none',
                        }}
                      >{`+${additionalPaidDrivers}`}</span>
                    )}
                </FlexView>
              )}
            </FlexView>
          )}
        </FlexView>
        {/* {
                    enableTooltip && 
                    <ReactTooltip className="packageTheme" id='global' delayHide={10} effect='solid' place='bottom'>
                        <FlexView style={{ textTransform: 'revert', fontStyle: 'normal', padding: 15, color: 'white', background: '#3A3F48' }} column>
                            <FlexView>
                                <span style={{ fontSize: fontSize, width: 200 }}>{translate("packageDetails.package")}</span>
                                <span style={{ fontSize: fontSize, fontWeight: 400 }}>{predefinedPackage ? `${PredefinedPackage[predefinedPackage]} ${packageMultiplier > 1 ? ' x' + packageMultiplier : ''}` : (activeDriversLimits ? activeDriversLimits : '?')}</span>
                            </FlexView>
                            <FlexView style={{ marginTop: 7 }}>
                                <span style={{ fontSize: fontSize, width: 200 }}>{translate("packageDetails.activeDrivers")}</span>
                                <span style={{ fontSize: fontSize, fontWeight: 400 }}>{driversCount}</span>
                            </FlexView>
                            {
                                driversCount != null && (activeDriversLimits != null || predefinedPackage != null) && driversCount > packageSize &&
                                <FlexView style={{ marginTop: 7 }}>
                                    <span style={{ fontSize: fontSize, width: 200, color: this.determineActiveDriversColor(driversCount, packageSize) }}>{translate("packageDetails.overflow")}</span>
                                    <span style={{ fontSize: fontSize, fontWeight: 500, color: this.determineActiveDriversColor(driversCount, packageSize) }}>{`${driversCount - packageSize}`}</span>
                                </FlexView>
                            }
                            <FlexView style={{ marginTop: 7 }}>
                                <span style={{ fontSize: fontSize, width: 200 }}>{translate("packageDetails.amount")}</span>
                                <span style={{ fontSize: fontSize + 3, fontWeight: 400 }}>{packageAmount + " PLN"}</span>
                            </FlexView>
                        </FlexView>
                    </ReactTooltip>
                } */}
      </FlexView>
    )
  }
}
